import { onKeyDownHandler, dialNumberSelectorHandler } from '@/methods/keyboardAccessibility'
import { importantCountries } from '../constants/importantCountries'

export const KEYS = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter']

export const handlePhonePrefix = (phone: string) => {
  const selectedFlag = document.querySelector('.iti__selected-flag') as HTMLElement
  const flagContainer = document.querySelector('.iti__flag-container') as HTMLElement
  const inputContainer = flagContainer.nextElementSibling as HTMLInputElement
  const buttonContainer = document.querySelector('.eid-button') as HTMLButtonElement

  if (inputContainer) {
    inputContainer.type = 'text'
    inputContainer.inputMode = 'numeric'

    const onInputKeyDown = (event: KeyboardEvent) => {
      onKeyDownHandler(event, () => {
        event.preventDefault()
        buttonContainer.click()
      })
    }

    inputContainer.removeEventListener('keydown', onInputKeyDown)
    inputContainer.addEventListener('keydown', onInputKeyDown)
  }

  const onSelectedFlagKeyDown = (event: KeyboardEvent) => {
    onKeyDownHandler(event, () => {
      event.preventDefault()
      dialNumberSelectorHandler()
      selectedFlag.click()
    })
  }

  selectedFlag.removeEventListener('keydown', onSelectedFlagKeyDown)
  selectedFlag.addEventListener('keydown', onSelectedFlagKeyDown)

  selectedFlag.click()

  const listElements = document.querySelectorAll('.iti__country-name')

  if (listElements.length) {
    const filteredDialNumbers = Array.from(listElements)
      .map((item) =>
        item.innerHTML
          .replace('<span class="iti__dial-code">', '|')
          .replace('</span>', '')
          .replace(/\s/g, '')
      )
      .map((item, i) =>
        item.split('|')[1] === phone.substring(0, 3) || item.split('|')[1] === phone.substring(0, 4)
          ? { index: i, name: item.split('|')[0], prefix: item.split('|')[1] }
          : undefined
      )
      .filter((x) => x)

    if (filteredDialNumbers.length) {
      if (filteredDialNumbers.length > 1) {
        const filteredDialNumber = filteredDialNumbers.filter((item) =>
          importantCountries.includes(item?.name || '')
        )

        if (filteredDialNumber.length && filteredDialNumber[0]) {
          ;(listElements[filteredDialNumber[0].index] as HTMLElement).click()
        } else if (filteredDialNumbers.length && filteredDialNumbers[0]) {
          ;(listElements[filteredDialNumbers[0].index] as HTMLElement).click()
        }
      } else if (filteredDialNumbers.length && filteredDialNumbers[0]) {
        ;(listElements[filteredDialNumbers[0].index] as HTMLElement).click()
      }
    }

    if (filteredDialNumbers[0]) {
      return phone.slice(filteredDialNumbers[0].prefix.length)
    }
  } else {
    return phone.slice(3)
  }
}
